module.exports = {
      id: "ic-rainbow-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-rainbow-usage",
      toString: function () {
        return this.url;
      }
    }